import { useMutation } from "@tanstack/react-query";
import { CreateAppFeedbackDto } from "breuer-supercharged-sdk";
import { AppFeedbackService } from "@/services/api/app_feedback";

export function useSubmitAppFeedback() {
    return useMutation({
        mutationFn: (dto: CreateAppFeedbackDto) =>
            AppFeedbackService.getInstance().createFeedback(dto),
    });
}
